// src/components/FloatingCursor.jsx
import { useEffect, useRef } from "react";
import "./index.css";  // keep your CSS file

const FloatingCursor = () => {
  const cursorRef = useRef(null);

  useEffect(() => {
    if (!cursorRef.current) return;

    let rafId;
    let targetX = -9999;
    let targetY = -9999;

    const animate = () => {
      if (cursorRef.current) {
        cursorRef.current.style.transform = `translate(${targetX}px, ${targetY}px)`;
      }
      rafId = requestAnimationFrame(animate);
    };

    const handleMouseMove = (e) => {
      targetX = e.clientX;
      targetY = e.clientY;
      if (!cursorRef.current.classList.contains('active')) {
        cursorRef.current.classList.add('active');
      }
    };

    const handleMouseOver = (e) => {
      const target = e.target.closest('a, button, input, textarea, [role="button"], .btn, .link-hover, .gm-ui-hover-effect, area, img');
      if (target) {
        cursorRef.current?.classList.add("hover");
      } else {
        cursorRef.current?.classList.remove("hover");
      }
    };

    window.addEventListener("mousemove", handleMouseMove, { passive: true });
    window.addEventListener("mouseover", handleMouseOver, { passive: true });
    rafId = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseover", handleMouseOver);
      cancelAnimationFrame(rafId);
    };
  }, []); // Run only once

  return (
    <div
      ref={cursorRef}
      className="custom-cursor"
      style={{
        position: "fixed",
        top: "0",
        left: "0",
        width: "0",
        height: "0",
        pointerEvents: "none",
        zIndex: 9999,
        willChange: "transform",
      }}
    />
  );
};

export default FloatingCursor;